import slugify from 'slugify'

/**
 * Generates a URL-safe slug from a string or array of strings
 *
 * @example
 * generateSlug('Hello World') // 'hello-world'
 * generateSlug(['John', 'Doe']) // 'john-doe'
 */
export function generateSlug(input: string | string[]): string {
  const stringToSlugify = Array.isArray(input) ? input.join(' ') : input

  return slugify(stringToSlugify, {
    lower: true,
    strict: true,
    remove: /[*+~.()'"!:@]/g
  })
}

/**
 * Check if a navigation link is active based on current path.
 * Used for aria-current and active styling in navigation components.
 */
export function isActiveLink(currentPath: string, linkUrl: string): boolean {
  return (
    currentPath === linkUrl ||
    (linkUrl !== '/' && currentPath.startsWith(linkUrl))
  )
}
